export interface Project {
  slug: string;
  name: string;
  tagline: string;
  description: string;
  role: string;
  stack: string[];
  highlights: string[];
  link?: string;
  images: string[];
}

const projects: Project[] = [
  {
    slug: "verdance-grow",
    name: "Verdance Grow",
    tagline:
      "AI-driven plant care app that diagnoses plant health, recommends treatments, and automates care schedules",
    description:
      "Grow is a mobile app designed to make plant care intuitive. It helps people take better care of their plants by turning their needs into simple, timely actions — based on the plant and its environment. Grow comes from a genuine interest in plant care and from the idea that looking after living things should feel natural, calm, and rewarding.",
    role: "Fullstack Engineer — Product Owner",
    stack: ["React Native", "TypeScript", "NestJS", "MongoDB"],
    highlights: [
      "Plant-aware scheduling system that adapts to species and environment",
      "End-to-end mobile experience from onboarding to daily care routines",
      "Backend service handling plant data, user profiles, and notification triggers",
    ],
    images: [
      "/projects/verdance-grow-1.avif",
      "/projects/verdance-grow-2.avif",
    ],
  },
  {
    slug: "verdance",
    name: "Verdance",
    tagline: "AI-enhanced blog and brand for plant enthusiasts",
    description:
      "Verdance.ch is a modern blog and brand concept for plant enthusiasts, enhanced by AI. It combines clean design, fresh content, and a forward-looking vision of how technology can deepen our relationship with nature.",
    role: "Fullstack Engineer — Frontend, CMS, AI Integration",
    stack: ["React", "TypeScript", "Next.js", "AI / LLM Integration"],
    highlights: [
      "AI-powered content curation and plant knowledge engine",
      "Clean editorial design built for reading and discovery",
      "Brand identity from concept to production deployment",
    ],
    link: "https://verdance.ch",
    images: ["/projects/verdance-1.avif", "/projects/verdance-2.avif"],
  },
  {
    slug: "raptor-woods",
    name: "Raptor Woods",
    tagline: "Educational Raptor Park on Lake Maggiore",
    description:
      "RaptorWoods.it is the official website of an educational park dedicated to birds of prey, nature, and environmental learning. The project showcases the park experience, activities for schools and families, and promotes on-site visits through emotional and informative storytelling.",
    role: "Fullstack Engineer — UX Strategy, Frontend, Content Architecture",
    stack: ["Next.js", "TypeScript", "Node.js"],
    highlights: [
      "Visit-oriented UX structure designed to drive physical park attendance",
      "Content architecture tailored for schools, families, and tourists",
      "Bilingual system (IT/EN) for local and international visitors",
    ],
    link: "https://raptorwoods.it",
    images: ["/projects/raptor-woods-1.jpeg", "/projects/raptor-woods-2.jpeg"],
  },
];

export default projects;
